export const PROJECT_NAME_TITLE = { en: 'Project name', th: 'ชื่อโครงการ' }
export const PROJECT_NAME_PLACEHOLDER = {
  en: 'e.g. Ashton Silom, The Address Asoke.',
  th: 'เช่น แอชตัน สีลม, ดิ แอดเดรส อโศก',
}
